"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrganizationSelect = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
/**
 * OrganizationSelect component - dropdown for selecting an organization
 */
const react_1 = require("react");
const Select_1 = require("./Select");
const LoadingSpinner_1 = require("./LoadingSpinner");
const organizationApi_1 = require("../helpers/organizationApi");
/**
 * OrganizationSelect component that loads and displays organizations
 * @param props - OrganizationSelectProps
 * @returns OrganizationSelect component
 */
const OrganizationSelect = ({ value, onChange, disabled = false, required = false, error, label = 'Organization', tenantId, }) => {
    const [organizations, setOrganizations] = (0, react_1.useState)([]);
    const [loading, setLoading] = (0, react_1.useState)(true);
    const [loadError, setLoadError] = (0, react_1.useState)(null);
    (0, react_1.useEffect)(() => {
        const loadOrganizations = () => __awaiter(void 0, void 0, void 0, function* () {
            setLoading(true);
            setLoadError(null);
            try {
                let data = tenantId
                    ? yield organizationApi_1.organizationApi.getOrganizationsByTenant(tenantId)
                    : yield organizationApi_1.organizationApi.getOrganizations();
                // Sort organizations alphabetically by name
                data = data.sort((a, b) => a.name.localeCompare(b.name));
                setOrganizations(data);
            }
            catch (err) {
                const errorMessage = err instanceof Error ? err.message : 'Failed to load organizations';
                setLoadError(errorMessage);
            }
            finally {
                setLoading(false);
            }
        });
        loadOrganizations();
    }, [tenantId]);
    const handleChange = (event) => {
        const selectedId = event.target.value;
        const selectedOrg = organizations.find((org) => org.id === selectedId) || null;
        onChange(selectedId, selectedOrg);
    };
    if (loading) {
        return ((0, jsx_runtime_1.jsx)("div", { className: "organization-select-loading", children: (0, jsx_runtime_1.jsx)(LoadingSpinner_1.LoadingSpinner, { size: "small", label: "Loading organizations..." }) }));
    }
    if (loadError) {
        return ((0, jsx_runtime_1.jsx)(Select_1.Select, { id: "organization-select", label: label, value: value, onChange: handleChange, options: [], error: loadError, disabled: true, required: required, placeholder: "Failed to load organizations" }));
    }
    const options = organizations.map((org) => ({
        value: org.id,
        label: org.name,
        disabled: org.active === false,
    }));
    return ((0, jsx_runtime_1.jsx)(Select_1.Select, { id: "organization-select", label: label, value: value, onChange: handleChange, options: options, error: error, disabled: disabled, required: required, placeholder: "Select an organization", fullWidth: true }));
};
exports.OrganizationSelect = OrganizationSelect;
exports.default = exports.OrganizationSelect;
